import Header from "./Components/Header";
import FooterWithSignup from "./Components/FooterWithSignup";
import "../styles/CookClubTerms.css";
import Footer from "./Components/Footer";
import SEO from "./Components/SEO";

function CookiesPolicy() {
    return (
        <div className="cookie-policy-page">
            <SEO
                title="Cookies Policy | DENNY"
                description="Read the Denny Cookies Policy to learn how we use cookies, analytics and similar technologies to improve your experience on our website."
                keywords="Denny cookies policy, cookie policy, website cookies, analytics cookies, POPIA, Denny South Africa"
            />
            <Header />

            <div className="cook-club-terms-container">
                <h1>Cookies Policy</h1>

                <p><strong>Last updated:</strong> 21 July 2026</p>

                <h2>1. Introduction</h2>

                <p>
                    This Cookies Policy explains how Denny uses cookies and similar
                    technologies when you visit the Denny website.
                </p>

                <p>
                    Denny is a brand within the Libstar Group, one of South Africa's
                    leading food manufacturing and branded consumer goods companies.
                    Libstar owns, develops, manufactures and distributes the Denny
                    brand as part of its portfolio of food brands.
                </p>

                <p>
                    This Cookies Policy should be read together with our Privacy
                    Policy and any other legal notices published on this website.
                </p>

                <h2>2. What Are Cookies?</h2>

                <p>
                    Cookies are small text files that are placed on your computer,
                    mobile phone, tablet or other device when you visit a website.
                </p>

                <p>
                    Cookies allow a website to recognise your device, remember your
                    preferences and understand how you interact with the website.
                    Some cookies are necessary for the website to function, while
                    others assist us with performance analysis, personalisation and
                    marketing.
                </p>

                <p>
                    Cookies do not usually identify you by name. However,
                    information collected through cookies, such as your IP address,
                    device information or online identifiers, may be regarded as
                    personal information under applicable data protection laws.
                </p>

                <h2>3. How We Use Cookies</h2>

                <p>Denny may use cookies and similar technologies to:</p>

                <ul>
                    <li>Ensure that the website operates correctly and securely.</li>
                    <li>Remember your preferences and cookie choices.</li>
                    <li>Improve website functionality and user experience.</li>
                    <li>Understand how visitors use and navigate the website.</li>
                    <li>Measure website traffic and campaign performance.</li>
                    <li>Display relevant content and advertising.</li>
                    <li>Support embedded content from third-party platforms.</li>
                    <li>Identify and resolve website performance or technical issues.</li>
                </ul>

                <h2>4. Types of Cookies We May Use</h2>

                <h3>4.1 Strictly Necessary Cookies</h3>

                <p>
                    These cookies are required for the website to operate correctly.
                    They may support functions such as website security, page
                    navigation, form submissions, session management and saving your
                    cookie preferences.
                </p>

                <p>
                    Strictly necessary cookies cannot generally be disabled through
                    our cookie management tool because the website may not function
                    properly without them.
                </p>

                <h3>4.2 Functional Cookies</h3>

                <p>
                    Functional cookies allow the website to remember choices you
                    make, such as your preferred language, location or display
                    settings.
                </p>

                <p>
                    These cookies help us provide a more convenient and personalised
                    website experience.
                </p>

                <h3>4.3 Analytics and Performance Cookies</h3>

                <p>
                    Analytics cookies help us understand how visitors interact with
                    the website.
                </p>

                <p>They may collect information such as:</p>

                <ul>
                    <li>The pages you visit.</li>
                    <li>The time spent on the website.</li>
                    <li>The links or buttons you select.</li>
                    <li>The type of browser and device you use.</li>
                    <li>The website or campaign that directed you to our website.</li>
                    <li>General location information derived from your IP address.</li>
                    <li>Technical errors encountered while using the website.</li>
                </ul>

                <p>
                    This information helps us measure website performance and improve
                    our content, functionality and user experience.
                </p>

                <p>
                    Analytics services may include tools such as Google Analytics or
                    similar website measurement platforms.
                </p>

                <h3>4.4 Advertising and Marketing Cookies</h3>

                <p>
                    Marketing cookies may be used to understand the effectiveness of
                    our advertising and promotional campaigns.
                </p>

                <p>They may also be used to:</p>

                <ul>
                    <li>Measure conversions resulting from advertisements.</li>
                    <li>Limit how frequently an advertisement is displayed.</li>
                    <li>Create audience groups for advertising campaigns.</li>
                    <li>Present advertising that may be more relevant to your interests.</li>
                    <li>Measure engagement with email, social media or digital campaigns.</li>
                </ul>

                <p>
                    These cookies may be placed by Denny or by third-party
                    advertising and social media platforms.
                </p>

                <h3>4.5 Social Media Cookies</h3>

                <p>
                    The website may contain links, buttons, videos or content from
                    social media services such as Facebook, Instagram, YouTube,
                    LinkedIn, TikTok or other platforms.
                </p>

                <p>
                    These platforms may place cookies on your device when you
                    interact with their content or visit a page containing an
                    embedded feature.
                </p>

                <p>
                    The use of these cookies is governed by the privacy and cookie
                    policies of the relevant third-party platform.
                </p>

                <h3>4.6 Embedded Content Cookies</h3>

                <p>
                    Certain pages may contain embedded content, including videos,
                    maps, forms, competitions or other content provided by third
                    parties.
                </p>

                <p>
                    Embedded content may behave as though you visited the third
                    party's website directly. The third party may collect
                    information, use cookies or track your interaction with the
                    embedded content.
                </p>

                <h2>5. First-Party and Third-Party Cookies</h2>

                <h3>First-Party Cookies</h3>

                <p>
                    First-party cookies are placed directly by the Denny website.
                    They are generally used to operate the website, remember your
                    preferences and understand website performance.
                </p>

                <h3>Third-Party Cookies</h3>

                <p>
                    Third-party cookies are placed by external service providers
                    whose services or content are used on the website.
                </p>

                <p>
                    These third parties may include analytics providers,
                    advertising platforms, social media platforms, video hosting
                    services and other technology providers.
                </p>

                <p>
                    Denny does not control how third parties use information
                    collected through their cookies. You should review the privacy
                    and cookie policies of the relevant third parties for further
                    information.
                </p>

                <h2>6. Session and Persistent Cookies</h2>

                <h3>Session Cookies</h3>

                <p>
                    Session cookies are temporary and are normally deleted when you
                    close your browser.
                </p>

                <h3>Persistent Cookies</h3>

                <p>
                    Persistent cookies remain on your device for a defined period or
                    until you delete them. They may be used to remember your
                    preferences or recognise your device during future visits.
                </p>

                <p>
                    The duration of a cookie depends on its purpose and the settings
                    applied by Denny or the relevant third-party provider.
                </p>

                <h2>7. Cookies Used on This Website</h2>

                <p>
                    The cookies used on the Denny website may change as website
                    functionality, service providers and marketing activities are
                    updated.
                </p>

                <p>
                    The website's cookie management tool should provide information
                    about the cookies currently in use, including:
                </p>

                <ul>
                    <li>The cookie name.</li>
                    <li>The cookie provider.</li>
                    <li>The purpose of the cookie.</li>
                    <li>The cookie category.</li>
                    <li>The period for which it is stored.</li>
                </ul>

                <p>
                    Where available, you can access this information by selecting
                    <strong> Cookie Settings </strong>
                    or
                    <strong> Manage Cookie Preferences</strong> on the website.
                </p>

                <h2>8. Your Cookie Choices</h2>

                <p>
                    When you first visit the website, you may be shown a cookie
                    notice that allows you to:
                </p>

                <ul>
                    <li>Accept all cookies.</li>
                    <li>Reject non-essential cookies.</li>
                    <li>Select the categories of cookies you wish to allow.</li>
                    <li>Review additional information about the cookies used.</li>
                </ul>

                <p>
                    Strictly necessary cookies may remain active because they are
                    required for the website to function.
                </p>

                <p>
                    Non-essential cookies should only be activated in accordance
                    with the choices you make through the cookie notice or
                    preference management tool.
                </p>

                <p>
                    You may change or withdraw your cookie preferences at any time
                    by selecting the Cookie Settings or Manage Cookie Preferences
                    link on the website.
                </p>

                <p>
                    Withdrawing your consent will not affect the lawfulness of any
                    processing that took place before your consent was withdrawn.
                </p>

                <h2>9. Managing Cookies Through Your Browser</h2>

                <p>
                    Most internet browsers allow you to view, block or delete
                    cookies through the browser settings.
                </p>

                <p>You may be able to configure your browser to:</p>

                <ul>
                    <li>Block all cookies.</li>
                    <li>Block cookies from particular websites.</li>
                    <li>Block third-party cookies.</li>
                    <li>Delete cookies when you close your browser.</li>
                    <li>Notify you before a cookie is placed.</li>
                </ul>

                <p>
                    Please note that blocking or deleting certain cookies may affect
                    the functionality, availability or performance of the website.
                </p>

                <p>
                    The steps required to manage cookies differ between browsers.
                    Please consult your browser's help or settings section for
                    further guidance.
                </p>

                <h2>10. Personal Information and POPIA</h2>

                <p>
                    Information collected through cookies may constitute personal
                    information under the Protection of Personal Information Act,
                    2013 (POPIA).
                </p>

                <p>
                    Where cookie information constitutes personal information, it
                    will be processed in accordance with applicable data protection
                    requirements and Denny's Privacy Policy.
                </p>

                <p>This includes taking reasonable steps to ensure that personal information is:</p>

                <ul>
                    <li>Collected for a specific and lawful purpose.</li>
                    <li>Processed fairly and transparently.</li>
                    <li>Limited to information that is relevant and necessary.</li>
                    <li>Protected against unauthorised access, loss or misuse.</li>
                    <li>Retained only for as long as reasonably necessary.</li>
                    <li>Shared only where there is a lawful basis for doing so.</li>
                </ul>

                <p>
                    POPIA does not specifically regulate cookies as a separate
                    technology, but online identifiers and other information
                    collected through cookies may fall within its definition of
                    personal information.
                </p>

                <h2>11. International Transfers</h2>

                <p>
                    Some third-party service providers may process cookie
                    information outside South Africa.
                </p>

                <p>
                    Where personal information is transferred outside South Africa,
                    reasonable steps will be taken to ensure that the information
                    receives an appropriate level of protection in accordance with
                    applicable law.
                </p>

                <h2>12. Changes to This Cookies Policy</h2>

                <p>
                    Denny may update this Cookies Policy from time to time to
                    reflect changes to:
                </p>

                <ul>
                    <li>The cookies used on the website.</li>
                    <li>Website functionality.</li>
                    <li>Third-party service providers.</li>
                    <li>Applicable laws or regulatory requirements.</li>
                    <li>Denny's business and marketing activities.</li>
                </ul>

                <p>
                    The updated policy will be published on this page together with
                    a revised <strong>Last updated</strong> date.
                </p>

                <p>
                    We encourage you to review this Cookies Policy periodically.
                </p>

                <h2>13. Contact Us</h2>

                <p>
                    For questions about this Cookies Policy, the use of cookies on
                    the website or the processing of your personal information,
                    please contact:
                </p>

                <p>
                    <strong>Denny</strong><br />
                    A brand within the Libstar Group<br />
                    Telephone: +27 23 614 2359<br />
                    Email: email@denny.co.za<br />
                    Address: 12 Barlinka Avenue, Montagu, 6720<br />
                    South Africa
                </p>
            </div>

            <Footer />
        </div>
    );
}

export default CookiesPolicy;
